import { useForm } from 'react-hook-form';
import useRegister, { Register } from '../../api/hooks/authentication/useRegister';
import { settingsInputs } from '../../consts/inputs';
import { toIcons } from '../../consts/Paths';
import useIsMobile from '../../hooks/useIsMobile';
import { getInputs } from '../../utils/getMethods';
import CustomInput from '../inputs/CustomInput';
import { useEffect } from 'react';
import useLogMessage from '../../hooks/useLogMessage';
import useToggle from '../../hooks/useToggle';
import LogMessage from '../misc/LogMessage';
import { logMsgBgColors } from '../../consts/misc';
import useCategory from '../../api/hooks/useCategory';
import useOffer from '../../api/hooks/useOffers';

const SettingsCreateSiteModal = (props: any) => {
    const { CTAs, RESPONSES } = useOffer();
    const { isMobile } = useIsMobile();
    const createNewUserForm = useForm();
    const { write } = props.logMessage;

    const onSubmit = (data: any) => {
        /* console.log("calling: create new user form"); */
        CTAs.createSite(data.name);
    };

    /* Setting Messsage */
    useEffect(() => {
        /* console.log(registerResponse, registerResult); */
        if (RESPONSES.createSiteResponse?.ok) {
            write('subject', 'Category ');
            write('other_text', 'has been added ');
            write('complement', 'successfully!');
            write('bgColor', logMsgBgColors.correct);
            props.toggler.toggle();
            props.resetList.toggle();
        } else if (RESPONSES.createSiteResponse?.ok === false) {
            write('subject', 'Category ');
            write('other_text', 'has not been addedd');
            write('complement', 'try again');
            write('bgColor', logMsgBgColors.error);
        }
    }, [RESPONSES.createSiteResponse]);
    /*  */

    const inputsArray = getInputs(settingsInputs, ['name']);
    const renderInputs = inputsArray.map((input, key) => {
        return (
            <CustomInput
                key={key}
                width={isMobile ? '100%' : 564}
                title={input.title}
                name={input.name}
                type={input.type}
                register={createNewUserForm.register}
                errors={createNewUserForm.formState.errors}
                {...input}
            />
        );
    });

    return (
        <div
            className='modal-wrapper'
            style={{
                height: `100vh`,
            }}
        >
            <div
                className='settings-edit-modal'
                style={{
                    width: isMobile ? '345px' : '',
                }}
            >
                <form onSubmit={createNewUserForm.handleSubmit(onSubmit)}>
                    <div className='settings-edit-modal-content' style={{ margin: isMobile ? '35px 19px 0 21px' : '' }}>
                        <div className='modal-header'>
                            <p className='modal-title'>Add site</p>
                            <div className='Oval' onClick={props.toggler.toggle}>
                                <img src={`${toIcons}/close.svg`} />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '25px',
                                marginTop: '22px',
                            }}
                        >
                            {renderInputs}
                        </div>
                        <button
                            style={{
                                marginRight: '0',
                                width: isMobile ? '100%' : '105px',
                            }}
                            className='modal-button'
                            type='submit'
                        >
                            <p className='modal-button-text'>Add</p>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default SettingsCreateSiteModal;
